import {
	getPackageTypesRequest,
	getPalletPackageTypesRequest,
	newPackageTypeRequest,
	deletePackageTypeRequest,
	updatePackageTypeRequest,
	syncPackageTypesRequest,
} from '../requests';
import { throttle, objectGet, objectSet } from '@/core';
import rdbClient from 'rdb-client';

async function getPackageTypes({ state, commit }, { force } = {}) {
	commit('set', (state) => { state.loading = true; });
	try {
		if (force || state.packageTypes.length === 0) {
			await fetchPackageTypes();
		} else {
			await throttle(fetchPackageTypes, 'fetchPackageTypes', 60 * 1000);
		}
	} catch (err) {
		console.error(err);
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });

	async function fetchPackageTypes() {
		let response = await getPackageTypesRequest();
		commit('setPackageTypes', response);
	}
}

async function getPalletPackageTypes({ state, commit }, { force } = {}) {
	commit('set', (state) => { state.loading = true; });
	try {
		if (force || state.palletPackageTypes.length === 0) {
			await fetchPalletPackageTypes();
		} else {
			await throttle(fetchPalletPackageTypes, 'fetchPalletPackageTypes', 60 * 1000);
		}
	} catch (err) {
		console.error(err);
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });

	async function fetchPalletPackageTypes() {
		let response = await getPalletPackageTypesRequest();
		commit('setPalletPackageTypes', response);
	}
}

async function addPackageType({ state, commit }) {
	let packageType = {
		id: undefined,
		packageCode: undefined,
		packageName: {
			en: undefined,
			no: undefined,
			dk: undefined
		},
		packageTypeCode: undefined,
		length: undefined,
		width: undefined,
		height: undefined,
		weight: undefined,
		chargableWeight: undefined,
		inactive: undefined,
		isPallet: undefined,
		palletPriceFactorPrice: undefined,
		palletPriceFactorTruck: undefined,
	};
	try {
		let response = await newPackageTypeRequest(packageType);
		packageType.id = response.id;
		let { packageTypes } = state;
		packageTypes.unshift(packageType);
		commit('set', () => { state.packageTypes = packageTypes; });
	} catch (err) {
		throw new Error('failedToAdd');
	}

	return packageType;
}

async function setPackageType({ commit }, { packageType, data, prop }) {
	if (objectGet(packageType, prop) === data) return;

	let packageTypeClone = JSON.parse(JSON.stringify(packageType));
	commit('set', () => { objectSet(packageType, prop, data); });
	let patch = rdbClient.createPatch(packageTypeClone, packageType);
	try {
		await updatePackageTypeRequest(packageType.id, { patch });
		commit('clearErrors');
	} catch (err) {
		if (err.response) {
			commit('setErrors', { errors: err.response.data.errors, id: packageType.id });
		}
		commit('set', () => { packageType[prop] = packageTypeClone[prop]; });
		throw (err);
	}
}

async function deletePackageTypes({ state, commit }, packageTypesToDelete) {
	let storedPackageTypes = state.packageTypes;
	let idsToRemove = [];
	for (let dPackageType of packageTypesToDelete) {
		idsToRemove.push(dPackageType.id);
	}
	try {
		for (let packageTypeId of idsToRemove) {
			await deletePackageTypeRequest(packageTypeId);
		}
		let updatedPackageTypes = storedPackageTypes.filter(term => idsToRemove.indexOf(term.id) < 0);
		commit('set', () => { state.packageTypes = updatedPackageTypes; });
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

async function syncPackageTypes() {
	try {
		await syncPackageTypesRequest();
	} catch (err) {
		throw new Error('failedToSync');
	}
}

export default {
	getPackageTypes,
	getPalletPackageTypes,
	addPackageType,
	setPackageType,
	deletePackageTypes,
	syncPackageTypes,
};
